import React, { Component } from 'react';
import PropTypes from 'prop-types';

/* Bell icon with the notification badge dispayed in the topbar. The popover menu itself
 * is a different component because:
 * - We have 2 bell icons in our markup, one for desktop and another for mobile, and we
 *   don't want to render the entire markup for the menu twice;
 * - Foundation includes lots of styles that influence elements in the topbar, so rendering
 *   the menu element outside the topbar element allows for simpler CSS. This is important
 *   since we have free-form markdown inside the menu;
 */
export default class NotificationsIcon extends Component {
  static propTypes = {
    open: PropTypes.bool,
    counter: PropTypes.number.isRequired,
    openTracking: PropTypes.string.isRequired,
  };

  static defaultProps = {
    open: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      open: this.props.open,
      counter: this.props.counter,
    };
  }

  componentDidMount() {
    $(document).on('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    $(document).off('click', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.state.open && !this.node.contains(e.target)) {
      // TODO Improve this code. If a click was made outside this component but inside the
      // Popover component, don't do anything. Also ignore if the popover details are open
      // or if the click was made inside a notification-triggered modal
      const popover = $('.Popover');
      const container = $('.ModalContainer');
      if (
        (popover.length > 0 && popover[0].contains(e.target)) ||
        (container.length > 0 && container[0].contains(e.target))
      ) {
        return;
      }
      this.handleClick();
    }
  };

  handleClick = (e) => {
    if (e) e.preventDefault();
    this.setState({ open: !this.state.open, counter: 0 }, () => {
      $(document).trigger('announcement-menu', [this.state.open]);
    });
  };

  notificationContent() {
    if (this.state.counter > 9) {
      return '•';
    } else if (this.state.counter > 0) {
      return this.state.counter;
    }
    return '';
  }

  render() {
    return (
      <a
        href="#"
        onClick={this.handleClick}
        ref={(node) => {
          this.node = node;
        }}
        className="u-relative u-flex">
        <i
          className={`Icon Icon-notification Announcement-icon u-text-xl md:u-text-md u-text-grey-dark`}
        />
        {this.state.counter > 0 && <span className="badge-indicator">{this.state.counter}</span>}
      </a>
    );
  }
}
